import { useState } from 'react';
import { useNormalizedOptions } from '../hooks/use-normalized-options.js';
/**
 * useFilterState
 * @param options
 * @param keysToFilterBy
 * @returns {}
 */
export const useFilterState = ({ defaultValue = '', externallyFiltered, keysToFilterBy = ['value', 'label'], options: rawOptions, }) => {
    const options = useNormalizedOptions(rawOptions);
    const [filterValue, setFilterValue] = useState(String(defaultValue));
    const searchBy = filterValue.toLowerCase();
    const filteredOptions = externallyFiltered
        ? Array.from(options)
        : options.filter((option) => {
            let found = false;
            for (const key of keysToFilterBy) {
                if (String(option[key] || '')
                    .toLowerCase()
                    .includes(searchBy)) {
                    found = true;
                    break;
                }
            }
            return found;
        });
    return {
        filterValue,
        filteredOptions,
        setFilterValue,
    };
};
